import styled from "styled-components";

interface BarProps {
  percentage: number;
  color: string;
  zIndex?: number;
}

export default styled.div<BarProps>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 5px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  min-width: max-content;
  background-color: ${({ color }) => color};
  z-index: ${({ zIndex }) => zIndex};

  font-size: 16px;
  color: #232323;

  & > span {
    z-index: 2;
  }
`;
